<template>
    <modal class="dl-form">
        <section class="form-container" slot="content">
            <h4 class="form-title">
                Download Report
            </h4>

            <section class="form-item">
                <h5 class="item-title">
                    Date
                </h5>

                <date-picker
                    class="date-picker"
                    format="YYYY-MM-DD"
                    type="date"
                    range
                    placeholder="Select date"
                    v-model="downloadForm.date"
                >
                    <div slot="header" class="picker-header">
                        <p>From</p>
                        <p>To</p>
                    </div>
                </date-picker>
            </section>

            <section class="form-item">
                <h5 class="item-title">
                    Time
                </h5>

                <date-picker
                    class="date-picker"
                    v-model="downloadForm.time"
                    type="time"
                    range
                    format="HH:mm"
                    placeholder="Select time"
                >
                    <div slot="header" class="picker-header">
                        <p>From</p>
                        <p>To</p>
                    </div>
                </date-picker>
            </section>

            <section class="form-controls">
                <button
                    class="btn-danger"
                    @click="$emit('close')"
                    :disabled="downloadFileLoading"
                >
                    Cancel
                </button>

                <button
                    class="btn-primary"
                    @click="downloadFile()"
                    :disabled="!isFormValid || downloadFileLoading"
                >
                    {{ downloadFileLoading ? 'Loading...' : 'Download' }}
                </button>
            </section>
        </section>
    </modal>
</template>

<script>
import Modal from '@/components/utils/Modal.vue'
import DatePicker from 'vue2-datepicker'
import { mapFields } from 'vuex-map-fields'

export default {
	props: ['id'],

	computed: {
		...mapFields('user', [
			'downloadForm',
			'downloadFileLoading',
			'downloadFileData'
		]),

		isFormValid () {
			const { date, time } = this.downloadForm

			if (!date || !time) return false

			return date.length === 2 && time.length === 2
		}
	},

	methods: {
		async downloadFile () {
			if (!this.isFormValid) return

			const { date, time } = this.downloadForm
			const { dateFormatter } = this.$options.filters

			const form = new FormData()

			form.append('id', this.$route.params.id)
			form.append('date_from', dateFormatter(date[0], 'YYYY-MM-DD'))
			form.append('date_to', dateFormatter(date[1], 'YYYY-MM-DD'))
			form.append('time_from', dateFormatter(time[0], 'HH:mm'))
			form.append('time_to', dateFormatter(time[1], 'HH:mm'))

			await this.$store.dispatch('user/getUserProfileDetails', form)

			if (!this.downloadFileData) return

			this.generatePdf()
		},

		generatePdf () {
			localStorage.setItem('reportData', JSON.stringify(this.downloadFileData))
			window.open(`/generate-report`, '_blank')
		}
	},

	components: {
		Modal,
		DatePicker
	}
}
</script>

<style lang="scss" scoped>
.form-container {
    width: 450px;
    box-shadow: 0 0 3px #00000029;
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;

    @include flex-column();

    .form-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #d3d3d3;
        width: 100%;
    }

    .form-item {
        width: 100%;
        margin-top: 15px;

        .item-title {
            font-size: 15px;
            margin-bottom: 5px;
            font-weight: 600;
        }

        .date-picker {
            width: 100%;
        }
    }

    .form-controls {
        margin-top: 25px;

        @include flex-row(flex-end);

        button {
            &:first-child {
                margin-right: 10px;
            }
        }
    }
}
</style>
